var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 0C7.8505 0 0 7.8505 0 17.5C0 27.1495 7.8505 35 17.5 35C27.1495 35 35 27.1495 35 17.5C35 7.8505 27.1495 0 17.5 0ZM17.5 31.8182C9.60485 31.8182 3.18182 25.395 3.18182 17.5C3.18182 9.60495 9.60485 3.18182 17.5 3.18182C25.3952 3.18182 31.8182 9.60495 31.8182 17.5C31.8182 25.395 25.395 31.8182 17.5 31.8182Z",
    fill: "#FE5D7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8645 11.4215C23.3021 10.8595 22.3908 10.8595 21.8285 11.4215L17.1087 16.1411L12.4577 11.4899C11.8954 10.9278 10.9841 10.9278 10.4217 11.4899C9.85945 12.0523 9.85945 12.9636 10.4217 13.5258L15.0727 18.1769L10.49 22.7597C9.92778 23.3221 9.92778 24.2335 10.49 24.7957C10.7712 25.0767 11.1395 25.2172 11.5081 25.2172C11.8764 25.2172 12.245 25.0767 12.5262 24.7957L17.1087 20.2131L21.7598 24.8642C22.041 25.1452 22.4094 25.2857 22.7779 25.2857C23.1463 25.2857 23.5148 25.1452 23.796 24.8642C24.3582 24.3018 24.3582 23.3904 23.796 22.8282L19.1449 18.1771L23.8645 13.4575C24.4267 12.8951 24.4267 11.9837 23.8645 11.4215Z",
    fill: "#FE5D7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimes);
export default __webpack_public_path__ + "static/media/times.6957541d04a5327254182414ad663f0a.svg";
export { ForwardRef as ReactComponent };